import { useEffect } from "react";

const SITE_NAME = "Ateno";
import { DEFAULT_DESCRIPTION, DEFAULT_IMAGE, resolveSeo } from "./seoMetadata";

function upsertMeta(name, content, attr = "name") {
  if (!content) return;
  let node = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute(attr, name);
    document.head.appendChild(node);
  }
  node.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement("link");
    node.setAttribute("rel", rel);
    document.head.appendChild(node);
  }
  node.setAttribute("href", href);
}

function syncJsonLd(jsonLd) {
  document.getElementById("seo-jsonld")?.remove();

  const nodes = Array.from(document.head.querySelectorAll('script[data-seo-jsonld="true"]'));
  const items = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];

  if (!items.length) {
    nodes.forEach((node) => node.remove());
    return;
  }

  items.forEach((item, index) => {
    const node = nodes[index] || document.createElement("script");
    node.type = "application/ld+json";
    node.dataset.seoJsonld = "true";
    node.textContent = JSON.stringify(item);
    if (!nodes[index]) document.head.appendChild(node);
  });

  nodes.slice(items.length).forEach((node) => node.remove());
}

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  canonical: canonicalUrl,
  image = DEFAULT_IMAGE,
  type = "website",
  robots = "index,follow",
  jsonLd,
  titleSuffix = true,
}) {
  useEffect(() => {
    const { canonical, title: pageTitle, image: absoluteImage } = resolveSeo({
      title, description, image, path, canonical: canonicalUrl, type, titleSuffix,
    });

    document.title = pageTitle;
    upsertMeta("description", description);
    upsertMeta("robots", robots);

    upsertMeta("og:title", pageTitle, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:type", type, "property");
    upsertMeta("og:url", canonical, "property");
    upsertMeta("og:image", absoluteImage, "property");
    upsertMeta("og:image:width", "1200", "property");
    upsertMeta("og:image:height", "630", "property");
    upsertMeta("og:site_name", SITE_NAME, "property");

    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", pageTitle);
    upsertMeta("twitter:description", description);
    upsertMeta("twitter:image", absoluteImage);

    upsertLink("canonical", canonical);

    syncJsonLd(jsonLd);
  }, [canonicalUrl, description, image, jsonLd, path, robots, title, titleSuffix, type]);

  return null;
}
